// extracted by mini-css-extract-plugin
export default {"form":"_04_Socials_form__nJzkw","root":"_04_Socials_root__ymSf2"};